export default __webpack_public_path__ + "static/media/Bobochic.f2c08596.png";